<template>
  <div
    class="material-container"
    :class="{ 'material-tab-container': source === 'tab' }"
  >
    <div class="flex-between material-header-content">
      <div class="flex-center">
        <img
          src="https://logo.wondercv.com/banners/iHPHvfDrNe7EwME.png"
          alt=""
        />
        求职礼包
      </div>
      <div class="material-btn flex-center" @click="handleToList">全部资料</div>
    </div>
    <div class="material-list-content">
      <material-item
        v-for="(item, index) in infoList"
        :key="index"
        :material-item-data="item"
        :invitations="invitations"
        @handleClickItem="handleClickItem"
      ></material-item>
    </div>
    <div class="flex-between material-header-content">
      <div class="flex-center">
        <img
          src="https://logo.wondercv.com/banners/msSidgxGCTKfMEc.png"
          alt=""
        />
        精品课程
      </div>
      <div class="material-btn flex-center" @click="handleToLessonPage">全部课程</div>
    </div>
    <div class="material-list-content course-list-content">
      <course-item
        class="course-item-wrapper"
        v-for="(item, index) in courseList"
        :key="index"
        :course-item-data="item"
        @handleClickItem="handleClickItem"
      ></course-item>
    </div>
    <w-tabbar v-if="source === 'tab'" page="strategy"></w-tabbar>
  </div>
</template>

<script>
import materialItem from './components/material-item.vue'
import courseItem from './components/course-item.vue'
import WTabbar from '../../components/global/w-tabbar'
import { envMixin, loginMixin } from '../../assets/js/mixin/global'
export default {
  components: {
    materialItem,
    courseItem,
    WTabbar,
  },
  mixins: [envMixin, loginMixin],
  data() {
    return {
      infoList: [],
      invitations: [],
      courseList: [],
      source: this.$route.query.source,
    }
  },
  methods: {
    handleClickItem(data) {
      if (data.category === 'info') {
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/campaign/campaign?src=${process.env.VUE_APP_HOST}/campaign/materials/${data.id}`,
          })
        } else {
          this.$router.push(`/campaign/materials/${data.id}`)
        }
      } else {
        this.$fn.jump(data.info_url)
      }
    },
    handleToLessonPage() {
      this.$fn.jump(
        `${window.location.origin}/lesson`,
        () => {
          this.$router.push(`/lesson`)
        }
      )
    },
    handleToList() {
      this.$fn.jump(
        `${window.location.origin}/campaign/materials/list`,
        () => {
          this.$router.push(`/campaign/materials/list`)
        }
      )
    },
    async fetchConfigurationInfos(category, size) {
      try {
        const { data, code } = await this.$api.campaign.getConfigurationInfos({
          category,
          page: 1,
          size,
        })
        if (code === 1000) {
          category === 'info'
            ? (this.infoList = data.infos)
            : (this.courseList = data.infos)

          category === 'info' && (this.invitations = data.invitations);
        }
      } catch (error) {
        console.error(`fetch configuration info error`, error)
      }
    },
  },
  async created() {
    await this.miniprogramAutoLogin();
    this.fetchConfigurationInfos('info', 4)
    this.fetchConfigurationInfos('course', 20)
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/global/mixin.scss';
.material-container {
  padding: 12px 16px 0;
  min-height: 100vh;
  background-color: #f9f9f8;
  @include ipx-content-bottom(15px);
  .material-header-content {
    font-size: 18px;
    font-weight: 500;
    color: #404040;
    line-height: 25px;
    margin-bottom: 13px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
    .material-btn {
      border: 1px solid #ececec;
      width: 76px;
      height: 24px;
      border-radius: 12px;
      font-size: 13px;
      color: #606060;
      font-weight: 400;
    }
  }
  .material-list-content {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 18px;
  }
  .course-list-content {
    flex-direction: column;
    padding: 20px 16px;
    background-color: #fff;
    border-radius: 6px;
    margin-bottom: 0;
    .course-item-wrapper {
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.material-tab-container {
  @include ipx-content-bottom(65px);
}
</style>
